import {
  Component,
  OnInit,
  HostListener
} from '@angular/core';
import { AuthService } from '../../../_infrastructure/services/auth/user-auth/auth.service';
import { MatDialog } from '@angular/material/dialog';
import { UnsubscribeOnDestroyAdapter } from '../../../_shared';
import { TrocarClienteComponent } from '../trocar-cliente/trocar-cliente.component';
import Swal from 'sweetalert2';
import { ConfiguracoesComponent } from '../configuracoes/configuracoes.component';
import { MeuPerfilComponent } from '../meu-perfil/meu-perfil.component';
import { Router } from '@angular/router';
import { PalavraChaveService } from '../../../_infrastructure/services/core/palavra-chave/palavra-chave.service';
import { PalavraChaveResponse } from '../../../_infrastructure/dtos/core/palavraChave/PalavraChaveResponse';
import { UsuarioResponse } from '../../../_infrastructure/dtos/core/usuario/UsuarioResponse';
import { UsuarioService } from '../../../_infrastructure/services/core/usuario/usuario.service';
import { MediaImageService } from '../../../_shared/utils/MediaImage.service';

@Component({
  selector: 'app-main-header',
  templateUrl: './main-header.component.html',
  styleUrls: ['./main-header.component.css'],
  standalone: false
})
export class MainHeaderComponent extends UnsubscribeOnDestroyAdapter implements OnInit {
  nome!: string;
  perfil!: string;
  nomeSocial!: string;
  email!: string;
  nomeFantasia!: string;
  palavrasChave: PalavraChaveResponse[] = [];
  searchTerm: string = '';
  sugestoes: PalavraChaveResponse[] = [];
  previewImage: string | null = null;
  usuario!: UsuarioResponse;

  constructor(private readonly authService: AuthService,
    public readonly dialog: MatDialog,
    private readonly router: Router,
    private readonly palavraChaveService: PalavraChaveService,
    private readonly usuarioService: UsuarioService,
    private readonly mediaImageService: MediaImageService,
  ) { super(); }

  ngOnInit() {
    this.subs.sink = this.authService.currentUser.subscribe(user => {
      if (user) {
        this.nome = user.nome;
        this.perfil = user.perfilNome;
        this.nomeSocial = user.nomeSocial;
        this.email = user.email;
        this.nomeFantasia = user.nomeFantasia;
        this.loadPalavraChave();
        this.loadUsuario();
      }
    });
  }

  loadPalavraChave() {
    this.palavraChaveService.getAllPortal()
      .subscribe({
        next: (res) => {
          this.palavrasChave = res.data;
        },
        error: (error) => {
          console.error(error);
        },
        complete: () => {
        }
      });
  }
  loadUsuario() {
    Swal.showLoading();
    this.usuarioService.getUserLogged()
      .subscribe({
        next: (result) => {
          this.usuario = result.data;
          if (this.usuario.pessoa.midia) {
            this.previewImage = this.mediaImageService.gerarPreview(this.usuario.pessoa.midia);
          }
        },
        error: (error) => {
          console.error(error);
        },
        complete: () => {
          Swal.close();
        }
      });
  }

  showProfile = false;


  toggleProfile() {
    this.showProfile = !this.showProfile;
  }
  @HostListener('document:click', ['$event'])
  onDocumentClick(event: MouseEvent): void {

    const target = event.target as HTMLElement;

    if (!target.closest('.dropdown-wrapper')) {
      this.showProfile = false;
    }
  }
  logout() {
    this.authService.logout();

    this.subs.sink = this.authService.currentUser
      .subscribe(user => {
        if (!user) {
          this.router.navigateByUrl('/authentication/signin');
        }
      });
  }

  getInitials(nome: string | null | undefined): string {
    if (!nome) return '';

    const partes = nome.trim().split(' ').filter(p => p.length > 0);

    if (partes.length === 1) {
      return partes[0]
        .substring(0, 2)
        .toUpperCase();
    }

    return partes
      .slice(0, 2)
      .map(p => p[0].toUpperCase())
      .join('');
  }

  trocarCliente() {
    const dialogRef = this.dialog.open(TrocarClienteComponent, {
      data: {
        data: {},
        action: 'Trocar Cliente',
      },
      disableClose: true,
      panelClass: 'dialog-rounded',
      maxWidth: 'auto',
      maxHeight: '100vh'
    });
    this.subs.sink = dialogRef.afterClosed().subscribe((result) => {
      if (result?.success) {
        Swal.fire("Sucesso", result.message || "Operação realizada com sucesso!", "success");
      } else if (result) {

      }
    });
  }

  configuracao() {
    const dialogRef = this.dialog.open(ConfiguracoesComponent, {
      data: {
        data: {},
        action: 'Trocar Cliente',
      },
      disableClose: true,
      panelClass: 'dialog-rounded',
      maxWidth: 'auto',
      maxHeight: '100vh'
    });
    this.subs.sink = dialogRef.afterClosed().subscribe((result) => {
      if (result?.success) {
        Swal.fire("Sucesso", result.message || "Operação realizada com sucesso!", "success");
      } else if (result) {

      }
    });
  }

  meuPerfil() {
    const dialogRef = this.dialog.open(MeuPerfilComponent, {
      data: {
        data: {},
        action: 'Trocar Cliente',
      },
      disableClose: true,
      panelClass: 'dialog-rounded',
      maxWidth: 'auto',
      maxHeight: '100vh'
    });
    this.subs.sink = dialogRef.afterClosed().subscribe((result) => {
      if (result?.success) {
        Swal.fire("Sucesso", result.message || "Operação realizada com sucesso!", "success");
      } else if (result) {

      }
    });
  }

  filtrar() {
    const termo = this.searchTerm?.toLowerCase().trim();

    if (!termo) {
      this.sugestoes = [];
      return;
    }

    this.sugestoes = this.palavrasChave
      .filter(p =>
        p.nome.toLowerCase().includes(termo) ||
        p.modulo?.nome.toLowerCase().includes(termo)
      )
      .slice(0, 8);
  }

  selecionar(item: PalavraChaveResponse) {
    this.searchTerm = item.nome;

    const url = item.modulo?.urlAcesso;

    if (!url) {
      return;
    }

    this.router.navigate([`/${url}`]);
  }

  limpar() {
    this.searchTerm = '';
    this.sugestoes = [];
  }


  darkColor = false;

  modetoggle() {
    this.darkColor = !this.darkColor;
    document.documentElement.setAttribute('data-theme', this.darkColor ? "darkTheme" : this.selectedColor);
    const button = document.getElementById('darkTheme');
    if (button) {
      button.title = this.darkColor ? 'Modo claro' : 'Modo escuro';
    }
  }

  selectedColor: string = "light";

  setColor(color: string) {
    this.selectedColor = color;
    document.documentElement.setAttribute('data-theme', color);
  }

  restaurarCor() {
    document.documentElement.setAttribute('data-theme', this.selectedColor);
  }
}
